(function() {
  'use strict';

  const ATTRIBUTE_KEY = 'triple_m_pos_review_contract_v1';
  const CONFIG_ID = 'triple-m-pos-review-authority';

  function rootUrl() {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function loadAuthority() {
    const element = document.getElementById(CONFIG_ID);
    if (!element) throw new Error('Review authority is unavailable.');
    const parsed = JSON.parse(element.textContent || 'null');
    const state = parsed?.state;
    if (
      !state ||
      state.version !== 1 ||
      typeof state.epoch !== 'string' ||
      !state.epoch ||
      typeof state.restrictions !== 'boolean'
    ) {
      throw new Error('Review state is unavailable.');
    }

    return state;
  }

  function variantGid(item) {
    const id = String(item?.variant_id || '');
    if (!/^[1-9][0-9]*$/.test(id)) throw new Error('Cart variant identity is invalid.');
    return 'gid://shopify/ProductVariant/' + id;
  }

  function buildContract(cart, state) {
    const seen = new Set();
    const lines = [];
    for (const item of cart?.items || []) {
      const gid = variantGid(item);
      if (seen.has(gid)) throw new Error('Duplicate variants require manual cart review.');
      seen.add(gid);
      lines.push({
        variantId: gid,
        reviewRequired: state.restrictions,
      });
    }
    if (lines.length < 1 || lines.length > 100) throw new Error('Cart size is unsupported.');
    lines.sort((a, b) => a.variantId.localeCompare(b.variantId));
    return {
      version: 1,
      epoch: state.epoch,
      lines,
    };
  }

  async function stampCart() {
    const authority = loadAuthority();
    const cartResponse = await fetch(rootUrl() + 'cart.js', {
      headers: { Accept: 'application/json' },
    });
    if (!cartResponse.ok) throw new Error('Unable to read the cart.');
    const cart = await cartResponse.json();
    const contract = buildContract(cart, authority);

    const updateResponse = await fetch(rootUrl() + 'cart/update.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [ATTRIBUTE_KEY]: JSON.stringify(contract),
        },
      }),
    });
    if (!updateResponse.ok) throw new Error('Unable to prepare checkout.');
    return contract;
  }

  function isCheckoutForm(form) {
    return form instanceof HTMLFormElement && Boolean(form.querySelector('[name="checkout"]'));
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!isCheckoutForm(form)) return;
    event.preventDefault();
    event.stopPropagation();
    const submitter = event.submitter;
    if (submitter instanceof HTMLButtonElement) submitter.disabled = true;
    try {
      await stampCart();
      window.location.assign(rootUrl() + 'checkout');
    } catch (error) {
      const liveRegion = document.getElementById('aria-live-region');
      if (liveRegion) {
        liveRegion.textContent =
          error instanceof Error ? error.message : 'Unable to prepare checkout. Refresh and try again.';
      }
      if (submitter instanceof HTMLButtonElement) submitter.disabled = false;
    }
  }, true);

  window.TripleMPosReviewContract = Object.freeze({
    attributeKey: ATTRIBUTE_KEY,
    buildContract,
    stampCart,
  });
})();
